<script setup>
import {computed} from 'vue'
import Button from "./Button.vue"
import api from '@/services/api'
import {usePageContentDataStore} from '@/stores/pageContentData'

const props = defineProps({
    pageContentId: Number
})

const pageContentDataStore = usePageContentDataStore()

// --- Computed ---

const pageContentLinkItem = computed(() => {
    return pageContentDataStore.items.find(o => o.id === props.pageContentId)
})

const contentItems = computed(() => {
    if (pageContentLinkItem.value) {
        return pageContentDataStore.items.filter(
            o => o.contentId === pageContentLinkItem.value.contentId
        )
    }
    return []
})

const count = computed(() => {
    const total = contentItems.value.length
    // Only show the count if the content is used in more than one place
    return total > 1 ? total : 0
})

// --- Methods ---

const unlinkContent = async () => {
    await api.post('api/unlink-content', {
        pageContentId: props.pageContentId,
    })

    /**
     * Refresh the page content items. This is crucial because unlinking
     * generates a new contentId for this specific pageContentId.
     */
    return pageContentDataStore.init()
}
</script>

<template>
    <div v-if="count" class="dropdown">
        <Button
            class="btn-sm border"
            title="Usage count"
            data-bs-toggle="dropdown"
        >
            {{ count }}
        </Button>

        <div class="dropdown-menu dropdown-menu-end p-1" @click.stop>
            <Button class="btn-sm w-100 text-start" @click="unlinkContent">
                Unlink content
            </Button>
        </div>
    </div>
</template>